import { any, equals, find } from 'ramda';

import { PROMO_CODE_URL_PARAM, PROMO_CODE_URL_PLACEHOLDER } from '../constants';
import getOpenUrlHandler from './openUrl';

export const parseCashierURL = ({ url: urlString, promoCode = '' }) => {
    const url = new window.URL(urlString, document.baseURI);
    const { searchParams } = url;

    searchParams.delete(PROMO_CODE_URL_PARAM);

    const paramToReplace = find(
        any(equals(PROMO_CODE_URL_PLACEHOLDER)),
        Array.from(searchParams)
    );

    if (paramToReplace) {
        searchParams.set(paramToReplace[0], promoCode);
    } else if (promoCode) {
        searchParams.append(PROMO_CODE_URL_PARAM, promoCode);
    }

    return url.href;
};

export default ({ promoCode, showNotification, urlTypeList, getURLs }) => {
    let actionHandler;
    let failureReason;

    const onRejected = (resolve) => {
        resolve('Absent URL template');
        showNotification('playtech.mobile.system.toast.cannotLaunchCashier', { variant: 'error' });
    };

    if (urlTypeList) {
        failureReason = new Promise((resolve) => {
            actionHandler = () => {
                getURLs({ urlTypeList })
                    .then((url) => {
                        if (url) {
                            const cashierUrl = parseCashierURL({ url, promoCode });
                            const { actionHandler: launchCashier } = getOpenUrlHandler([cashierUrl]);

                            if (launchCashier) {
                                resolve();
                                launchCashier();
                                return;
                            }
                        }

                        onRejected(resolve);
                    })
                    .catch(() => onRejected(resolve));
            };
        });
    } else {
        failureReason = 'Absent URL template';
        actionHandler = () => showNotification('playtech.mobile.system.toast.cannotLaunchCashier', { variant: 'error' });
    }

    return { actionHandler, failureReason };
};
